import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchSelfServiceOutOfStock = (retailerId) => {
  const { url } = DepsService.rest.widgets.common;
  const queryParams = { retailerId };
  const urlParams = {
    type: 'lvm13Weeks',
  };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const downloadLvmReport = (retailerId) => {
  const { url } = DepsService.rest.widgets.instant.lvm.downloadReport;
  const queryParams = { retailerId };
  const urlParams = {};

  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/self-service-out-of-stock.api.js